import { PropertyRef, defineBool, defineEnum } from '@spotify-internal/remote-config-properties';

/**
 * Define properties here and add them into the following array.
 * More on `docs/RemoteConfig/properties.md`
 */
export const ubiTestBool = defineBool({
  name: 'ubiTest',
  description: 'A/A-test to confirm integration towards UBI',
  default: false,
});

// HackWeek 27 - 31 March 2023
// Second Experiment (4th May)
// The control will show the survey option (ReasonSelector component)
// The target will omit that step.
export enum FeedbackStatus {
  SHOW_SURVEY = 'SHOW_SURVEY',
  DO_NOT_SHOW_SURVEY = 'DO_NOT_SHOW_SURVEY',
  ORIGINAL = 'ORIGINAL',
}

export const showSurveyOptionEnum = defineEnum({
  name: 'showSurveyOption',
  description: 'A/B-test to improve the UX in the FeedbackWidget',
  values: FeedbackStatus,
  default: FeedbackStatus.ORIGINAL,
});

export const usePillowTalk = defineBool({
  name: 'usePillowTalk',
  description: 'Boolean to control wether or not to use pillow talk',
  default: false,
});

/**
 * Find a way voices rollout (FA-3243)
 */
export const findawayVoicesBool = defineBool({
  name: 'findawayVoicesLaunched',
  description: 'Boolean to control the Find a Way Voices Turnkey site visibility',
  default: false,
});

export const useTurnkeyMastheadInConsumerBool = defineBool({
  name: 'useTurnkeyMastheadInConsumer',
  description: 'Boolean to control whether or not to use turnkey masthead for consumer vertical',
  default: false,
});

export const properties: Array<PropertyRef> = [
  ubiTestBool,
  showSurveyOptionEnum,
  usePillowTalk,
  findawayVoicesBool,
  useTurnkeyMastheadInConsumerBool,
];

export type PropertyTypes = (typeof properties)[number]['_type'];
